import { render, staticRenderFns } from "./orgOne.vue?vue&type=template&id=6a9e5da8&scoped=true"
import script from "./orgOne.vue?vue&type=script&lang=js"
export * from "./orgOne.vue?vue&type=script&lang=js"
import style0 from "./orgOne.vue?vue&type=style&index=0&id=6a9e5da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9e5da8",
  null
  
)

export default component.exports